var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex text-h5"},[_c('div',[_vm._v("Allez sur l'URL indiquée sur votre planche photo ou scannez le QR Code")])])}]

export { render, staticRenderFns }